import { createAction } from '../../store.model';
import { PersonOfInterestModel } from '../../user/people-of-interest.user.model';
import { PerformanceMetricData } from '../models/performance-metric-data.model';
import { ActionType } from '../my-performance-card.action';

export interface GetMetricPerformanceDataAction {
    userId: number;
}

export const getMetricPerformanceData = createAction<
    ActionType,
    GetMetricPerformanceDataAction
>(ActionType.MY_PERFORMANCE_CARD__GET_METRIC_PERFORMANCE_DATA);

export interface GetMetricPerformanceDataResultAction {
    metricPerformanceData: PerformanceMetricData[];
    poiUserData: PersonOfInterestModel[];
    userIdsHaveOtherManagers: number[];
    userId: number;
}

export const getMetricPerformanceDataResult = createAction<
    ActionType,
    GetMetricPerformanceDataResultAction
>(ActionType.MY_PERFORMANCE_CARD__GET_METRIC_PERFORMANCE_DATA_RESULT);
